<template>
  <div
    class="trustpilot-widget"
    data-locale="en-US"
    data-template-id="5419b6a8b0d04a076446a9ad"
    data-businessunit-id="5e2e8b4b0f7e88000156d39e"
    data-style-height="30px"
    data-style-width="100%"
    data-theme="light"
  >
    <a
      href="https://www.trustpilot.com/review/quickwill.co.za"
      target="_blank"
      rel="noopener"
      >Trustpilot</a
    >
  </div>
</template>

<script>
  export default {
    name: 'Trustpilot',
    head: {
      script: [
        {
          type: 'text/javascript',
          src: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
          async: true,
        },
      ],
    },
  };
</script>

<style lang="scss" scoped>
  .trustpilot-widget {
    margin-top: 30px;
    margin-bottom: 20px;
    max-width: 280px;
  }
</style>
